/**
 * Server function for the guide/playbook detail-page series navigation.
 *
 * Aliases: series, cih series, series nav fetch, series siblings fetch
 */

import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import type { PublishedSeriesMembers } from "~/lib/server/cih/series";
import { seriesFamilySchema } from "~/lib/shared/content-status";

export type { PublishedSeriesMembers } from "~/lib/server/cih/series";

/**
 * Every published guide and playbook in `family` (public — no auth
 * required). Callers derive previous/next/position/total from this via
 * `buildSeriesNav` in `~/lib/shared/cih/library-series`.
 */
export const getPublishedSeriesMembersFn = createServerFn({ method: "POST" })
  .validator(z.object({ family: seriesFamilySchema }))
  .handler(async ({ data }): Promise<PublishedSeriesMembers> => {
    const { getPublishedSeriesMembers } =
      await import("~/lib/server/cih/series");
    return getPublishedSeriesMembers(data);
  });
